// Camera Constants - 2ECOMP Fleet Management
// Server config (CAMERA_SERVER) removed — use useCameraServer() hook instead.

// Channel Names
export const CHANNEL_NAMES = {
  1: 'Frontal',
  2: 'Traseira',
  3: 'Lateral D',
  4: 'Lateral E',
  5: 'Motorista',
  6: 'Passageiro',
  7: 'Carga',
  8: 'Auxiliar',
};

// Channel Icons (Material UI icon names)
export const CHANNEL_ICONS = {
  1: 'DirectionsCar',      // Front-facing
  2: 'Person',             // Driver/cabin
  3: 'ChevronLeft',        // Left side
  4: 'Visibility',         // Rear
  5: 'ChevronRight',       // Right side
  6: 'Videocam',
  7: 'Videocam',
  8: 'Videocam',
};

// Stream Quality Options
export const STREAM_QUALITY = {
  MAIN: 'main',           // HD quality
  SUB: 'sub',             // Lower quality, less bandwidth
  AUTO: 'auto',           // Adaptive
};

// Stream Protocols
export const STREAM_PROTOCOLS = {
  WEBRTC: 'webrtc',       // Lowest latency (<500ms)
  FLV: 'flv',             // Low latency (1-3s)
  HLS: 'hls',             // High compatibility (5-10s)
  WS_FLV: 'ws-flv',       // WebSocket FLV
};

// Event Types that trigger video recording
export const VIDEO_TRIGGER_EVENTS = [
  'alarm',
  'deviceOverspeed',
  'hardAcceleration',
  'hardBraking',
  'hardCornering',
  'accident',
  'sos',
  'geofenceEnter',
  'geofenceExit',
  'ignitionOn',
  'ignitionOff',
];

// Default Recording Settings
export const RECORDING_DEFAULTS = {
  preEventSeconds: 10,    // Seconds before event
  postEventSeconds: 10,   // Seconds after event
  maxClipDuration: 60,    // Max clip duration in seconds
};

// Player Settings
export const PLAYER_SETTINGS = {
  reconnectAttempts: 3,
  reconnectDelay: 2000,   // ms
  bufferDuration: 1,      // seconds
  maxBufferLength: 30,    // seconds for HLS
  lowLatencyMode: true,
};

// Grid Layout Options
export const GRID_LAYOUTS = {
  SINGLE: { cols: 1, rows: 1 },
  DUAL: { cols: 2, rows: 1 },
  QUAD: { cols: 2, rows: 2 },
  SIX: { cols: 3, rows: 2 },
  NINE: { cols: 3, rows: 3 },
};

// Stream Duration Limit Options (minutes)
export const STREAM_DURATION_OPTIONS = [
  { value: 1, label: '1 min' },
  { value: 3, label: '3 min' },
  { value: 5, label: '5 min' },
  { value: 10, label: '10 min' },
  { value: 15, label: '15 min' },
  { value: 30, label: '30 min' },
];

export const STREAM_DURATION_DEFAULTS = {
  defaultMinutes: 5,
  warningBeforeSeconds: 60,
  extendMinutes: 5,
  localStorageKey: 'cameraStreamDurationMinutes',
};
